import { render, staticRenderFns } from "./EventDetailsView.vue?vue&type=template&id=7b9999d0&scoped=true"
import script from "./EventDetailsView.vue?vue&type=script&lang=js"
export * from "./EventDetailsView.vue?vue&type=script&lang=js"
import style0 from "./EventDetailsView.vue?vue&type=style&index=0&id=7b9999d0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b9999d0",
  null
  
)

export default component.exports